import { useEffect, useState } from "react";
import Hero from "@/components/sections/Hero";
import ValuePropTeaser from "@/components/sections/ValuePropTeaser";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import CaseStudies from "@/components/sections/CaseStudies";
import IndustriesMarquee from "@/components/sections/IndustriesMarquee";
import ServicesGrid from "@/components/sections/ServicesGrid";
import AboutStats from "@/components/sections/AboutStats";
import SimpleProcess from "@/components/sections/SimpleProcess";
import Testimonials from "@/components/sections/Testimonials";
import CTABanner from "@/components/sections/CTABanner";
import { api } from "@/lib/api";

export default function Home() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="home-page">
      <Hero />
      <ValuePropTeaser />
      <WhyChooseUs />
      <CaseStudies />
      <IndustriesMarquee />
      <ServicesGrid />
      <AboutStats stats={stats} />
      <SimpleProcess />
      <Testimonials />
      <CTABanner />
    </div>
  );
}
